import { render, staticRenderFns } from "./workerAdd1.vue?vue&type=template&id=f617fe68&scoped=true&"
import script from "./workerAdd1.vue?vue&type=script&lang=js&"
export * from "./workerAdd1.vue?vue&type=script&lang=js&"
import style0 from "./workerAdd1.vue?vue&type=style&index=0&id=f617fe68&scoped=true&lang=css&"
import style1 from "./workerAdd1.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f617fe68",
  null
  
)

export default component.exports